export const fr = {
  imageGalleryPage: {
    page_title: 'Galerie',
    header: {
      title: "Galerie d'images",
      description:
        'Photos des activités de bénévolat précédentes au sein de votre entreprise',
      greenshield_disclaimer:
        "Veuillez noter que les photos publiées dans la galerie d’images de Purposely peuvent être utilisées à des fins de communication interne et externe. Elles peuvent être diffusées dans notre intranet, nos bulletins d’information, nos rapports, nos présentations, nos médias sociaux et d’autres communications d’entreprise.",
    },
    my_photos: {
      title: 'Mes photos',
      empty_state: {
        title: "Vous n'avez pas encore téléchargé de photos",
        description:
          'Participez à une opportunité et téléchargez des photos pour les voir ici',
      },
      view_all: 'Voir tout',
      photo_count: '+{{count}} photos',
    },
    albums: {
      title: 'Photos des autres événements de votre entreprise',
      filter: {
        all_opportunities: 'Toutes les opportunités',
        your_opportunities: 'Vos opportunités',
      },
      results_count: '{{count}} Résultats',
      empty_state: {
        all: {
          title: "Aucun album d'entreprise pour le moment",
          description:
            'Lorsque votre entreprise termine une opportunité, les photos téléchargées apparaîtront ici',
        },
        yours: {
          title: 'Aucun album pour le moment',
          description:
            'Lorsque vous terminez une opportunité, téléchargez des photos pour les voir ici',
        },
      },
      photo_count: '{{count}} Photos',
    },
    upload_modal: {
      title: 'Télécharger des photos vers {{eventName}}',
      description:
        'Partagez les photos de cet événement avec tout le monde chez {{companyName}}',
      greenshield_disclaimer:
        "Veuillez noter que les photos publiées dans la galerie d’images de Purposely peuvent être utilisées à des fins de communication interne et externe. Elles peuvent être diffusées dans notre intranet, nos bulletins d’information, nos rapports, nos présentations, nos médias sociaux et d’autres communications d’entreprise.",
      submit: 'Soumettre',
    },
  },
}
